// removed by extract-text-webpack-plugin
module.exports = {"container":"YQlqfLFyIbHORPBz1GTXi","title":"_1k4sF4xHitAuY6ncW1rnE5","btnPago":"_1kacKdw9NalPfAAGmczNAS","noTable":"_3tIi-D1VveZPh8rGnLsrOZ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/Payments/PackPayment/styles.css
// module id = 2657
// module chunks = 0